/* unplugin-vue-components disabled */import { render } from "./GrasshopperHome.vue?vue&type=template&id=6dd1bec0"
import script from "./GrasshopperHome.vue?vue&type=script&lang=js"
export * from "./GrasshopperHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__